import { Close } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { defaultStore } from "shared/common/stores/defaultStore";
import { sidebarStore } from "shared/common/stores/sidebarStore";
import SingleFeatureTable from "shared/ui/toolbar/tools/layertreeAndEdit/featureTable/SingleFeatureTable";

export default function ImageFeatureInfo() {
  const { t } = useTranslation();

  const viewer = defaultStore((state) => state.viewer);
  const darkTheme = defaultStore((state) => state.darkTheme);

  const changeSelectedTableRows = sidebarStore(
    (state) => state.changeSelectedTableRows
  );
  const selectedTableRows = sidebarStore((state) => state.selectedTableRows);

  //deselect feature and remove feature infos section
  const handleCloseFeature = () => {
    handleRemoveActiveFeature();
    changeSelectedTableRows(undefined);
  };

  //deselect feature
  const handleRemoveActiveFeature = () => {
    if (viewer === undefined) return;
    const layer = viewer.getScene().getLayerHandler().getActiveLayer();
    if (layer) {
      layer.featureselector.clearSelection();
    }
  };

  return (
    <Box
      width="100%"
      height={selectedTableRows ? "60%" : "0%"}
      display="flex"
      flexDirection={"column"}
      sx={{
        transition: "height 0.3s",
      }}
    >
      {selectedTableRows && (
        <Box
          height={"100%"}
          display={"flex"}
          flexDirection="column"
          gap={1}
          paddingX={1.5}
          paddingY={1.5}
          sx={{
            overflow: "hidden",
            backgroundColor: darkTheme ? "darkblue.main" : "white",
            borderRadius: "10px",
            transition: "height 0.3s , margin 0.3s , padding 0.3s",
          }}
        >
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
          >
            <Typography
              overflow={"hidden"}
              textOverflow={"ellipsis"}
              fontSize={"18px"}
              fontWeight={700}
              color={darkTheme ? "white" : "darkblue.main"}
            >
              {t("layers_window.feature_title_info")}
            </Typography>
            <IconButton
              onClick={handleCloseFeature}
              disableRipple={true}
              sx={{
                padding: 0,
                color: darkTheme ? "white" : "darkblue.main",
                "@media (hover: hover)": {
                  ":hover": { color: "secondary.main" },
                },
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <SingleFeatureTable selectedTableRows={selectedTableRows} />
        </Box>
      )}
    </Box>
  );
}
